<template>    
    <ComboBox :key="componentKey"
        :style="{ width: comboBoxWidth }"
        :data-items="dataItems"
        :text-field="'value'"
        :data-item-key="'key'"                
        :allow-custom="true"
        :filterable="true"
        :value-field="'key'"        
        :value-primitive="true"
        v-model="value"
        :label="label"
        :tabIndex="tabIndex"
        size="small"
        :floating-label="noLabel"
        @change="selectionChanged"
        @filterchange="filterChanged"
      ></ComboBox>
</template>

<script lang="ts">
import {defineComponent, onUnmounted, reactive, ref, watch} from "vue"    
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from "@progress/kendo-vue-dropdowns";
import { ComboBoxDataSource } from "./ComboBoxDataSource";
import { NamedListItem } from "@/infrastructure/generics/namedListItem";
import { filterBy } from '@progress/kendo-data-query';
import { MandantBereichServiceForRoot } from "@/infrastructure/observables/mandantBereichState";
import { GridExtension } from "@/components/dynamic/GridExtension";
import { switchMap } from "rxjs";

export default defineComponent ({
    name: "DataComboBox",
    components: {
        ComboBox
    },
    inheritAttrs: false,
    emits: {
    selectionChanged: (rows: any) => true,
    },
    props: {
        dataSourceName: {
            type: String,
            require: true,
            default: null,            
        },
        filter: {
            type: String,
            require: true,
            default: null,            
        },
        selectedId: {
            type: Number,
            require: true,
            default: -1,
        },
        label: {
            type: String,
            require: true,
            default: ""
        },
        width: {
            type: String,
            require: true,
            default: "200px",     
        },
        tabIndex: {
            type: Number,
            require: false,
            default: 0
        },
        isBereichsFilter: {
            type: Boolean,
            require: false,
            default: false
        },
        refresh: {
            type: Date,
            default: new Date(),
            require: false
        },
        noLabel: {
            type: Boolean,
            require: false,
            default: false
        }
    },
    setup(props, {emit}) {
        const parameter = reactive({
            dataSourceName: props.dataSourceName,
            filter: props.filter,
            lifeFilter: ""
        })

        
        const componentKey = ref(0);

        const forceRender = () => {
            componentKey.value += 1;
        }

        const value = ref(props.selectedId)
        const comboBoxWidth = ref(props.width)
        const tabIndex = ref(props.tabIndex)
       
        const origDataItems = ref<NamedListItem[] | undefined>([{key:0,value:""}])
        const dataItems = ref<NamedListItem[] | undefined>([{key:0,value:""}])


        const mandantBereichService = MandantBereichServiceForRoot.getMandantBereichStateService();
        const mandantBereichSubscription = mandantBereichService.subscription().pipe(
            switchMap(async (value) => {
                if (props.isBereichsFilter) {
                    parameter.lifeFilter = GridExtension.getFilterValue(value);
                    //await load("subscription");
                }
            })
            ).subscribe();


        function filterChanged( e: ComboBoxFilterChangeEvent) {
            dataItems.value = filterData(e.filter);
        }

        function filterData(filter: any) : any {            
            return filterBy((origDataItems.value as NamedListItem[]), filter);
        }

        function selectionChanged(e: ComboBoxChangeEvent) {
            emit("selectionChanged", e.value)
        }

        watch(() => props.selectedId,(selection: any) => {
            value.value = selection
        }, {deep: true});

        watch(() => props.filter,(filter: any) => {
            value.value = filter
            parameter.filter = filter
            load("filterChanged")
        }, {deep: true});

        watch(() => props.refresh,(refresh: any) => {    
            value.value = 0       
            load("Refresh")
        }, {deep: true});

        async function load(where: string) {
            try {

             
              if(!dataItems || !origDataItems) return
              dataItems.value = await ComboBoxDataSource.GetList(parameter.dataSourceName, parameter.filter, parameter.lifeFilter)
              origDataItems.value = dataItems.value?.slice()
              forceRender()
            } catch (error) {
                console.log(error)
            }
            
        }

        load("general")
        
        onUnmounted(() => {
            mandantBereichSubscription.unsubscribe()
        })

        return {
            parameter,
            value,
            selectionChanged,
            filterChanged,
            comboBoxWidth,
            dataItems,
            origDataItems,
            tabIndex,
            componentKey
            }
    }
})
</script>